import React, { useMemo } from 'react';
import compose from 'lodash/fp/compose';
import {
  withTranslation,
  withUserPreferences,
  withCustomRouter,
  withAdminOrgFunctionProposal,
  withOrganisationFunction,
  withReligion,
  withSchoolType,
} from 'components/hoc';
import LottieLoader from 'components/common/LottieLoader';
import AdminContentTemplate from 'components/Admin/common/AdminContentTemplate';

const truncate = (name) => name && name.length > 25 ? `${name.substring(0, 25)}...` : name;

const approvalLabels = {
  N: 'Pending',
  A: 'Approved',
  D: 'Disapproved',
};

const lookupName = (id, options, trObj) => {
  if (id == null) return '-';
  if (!options?.length) return id;
  const found = options.find((opt) => String(opt.id) === String(id) || opt.id === id);
  if (found) return trObj ? trObj(found) : (found.name || found.long_description_eng || id);
  return id;
};

const ProposalFunction = (props) => {
  const {
    loaded,
    trObj,
    adminOrgFunctionProposal,
    orgFunctionLocaleOptions,
    religionLocaleOptions,
    schoolTypeOptions,
    bulkDeleteOrgFunctionProposals,
  } = props;

  const data = useMemo(() => {
    const proposals = adminOrgFunctionProposal?.proposals || [];
    return proposals.map((proposal) => {
      const { organisation_function, religion, school_type, approval } = proposal;
      return {
        ...proposal,
        organisation: truncate(proposal.organisation_detail?.name || '-'),
        organisation_function: lookupName(organisation_function, orgFunctionLocaleOptions, trObj),
        religion: lookupName(religion, religionLocaleOptions, trObj),
        school_type: lookupName(school_type, schoolTypeOptions, null),
        approval: approvalLabels[approval] || approval || '-',
      };
    });
  }, [adminOrgFunctionProposal?.proposals, orgFunctionLocaleOptions, religionLocaleOptions, schoolTypeOptions, trObj]);

  if (!loaded) return <LottieLoader />;

  return (
    <AdminContentTemplate
        tableName="organisation_function_proposal"
        columns={[]}
        data={data}
        useAddModalForm={false}
        bulkDelete={bulkDeleteOrgFunctionProposals}
      />
  );
};

export default compose(
  withTranslation,
  withCustomRouter,
  withUserPreferences,
  withOrganisationFunction,
  withReligion,
  withSchoolType,
  withAdminOrgFunctionProposal,
)(ProposalFunction);